import { isJSON } from './general-helper'

export function setItemInStorage(key: string, payload) {
  localStorage.setItem(
    key,
    typeof payload === 'string' ? payload : JSON.stringify(payload),
  )
}

export function getItemFromStorage(key: string) {
  const data = localStorage.getItem(key)
  if (isJSON(data)) {
    return JSON.parse(data)
  }
  return data
}

export function removeItemFromStorage(key: string) {
  localStorage.removeItem(key)
}

export function clearItemsFromStorage() {
  localStorage.clear()
}
